import { render, staticRenderFns } from "./MultipleCouponForm.vue?vue&type=template&id=8d8b37b0&scoped=true&"
import script from "./MultipleCouponForm.vue?vue&type=script&lang=js&"
export * from "./MultipleCouponForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d8b37b0",
  null
  
)

export default component.exports